// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"267":"af5e23fe3f68e456","1933":"e604fa38da650405","2869":"771bdf41b91b31c8","6327":"fc110f2473d18803","7963":"13a876572bbe6dca"}[chunkId] + ".css";
};